import { combineReducers } from 'redux-immutable';
import { createResponsiveStateReducer } from 'redux-responsive';

import reviews from 'src/store/reviews/slice';
import { BREAKEPOINTS } from '../../../../constants';
import { staticMap } from '../../../../utils/immutableUtils';

// global store
import feedback from '../../../../store/feedback/slices';
import client from '../../../../store/client/reducers';
import menu from '../../../../store/menu/slice';
import wishlist from '../../../../store/wishlist/slice';
import enqueue from '../../../../store/enqueue/reducers';
import headerWidget from '../../../../store/headerWidget/reducers';

import hotel from './hotel';
import view from './view';
import assets from './assets';
import pagination from './pagination';

const rootReducer = combineReducers({
  feedback,
  client,
  menu,
  wishlist,
  hotel,
  enqueue,
  //
  browser: createResponsiveStateReducer(BREAKEPOINTS),
  breadcrumbs: staticMap,
  view,
  reviews,
  ratings: staticMap,
  images: staticMap,
  assets,
  pagination,
  headerWidget,
});

export default rootReducer;
